import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

function useTargetListStyle() {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { colors } = useTheme();
  const flexListStyle = {
    appearance: 'none' as const,
    border: '0.0625rem solid',
    color: colors[colorStyle.color.primary],
    outline: 0,
    position: 'relative' as const,
    transition: 'all .2s',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingTop: '12px',
    paddingBottom: '5px',
    // width: '100%',
    backgroundColor: 'transparent',
    borderColor: colors['gray:60'],
    overflow: 'auto',
  };
  const descriptionStyle = {
    color: colors[colorStyle.color.secondary],
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '2px',
    marginBottom: '16px',
  };
  const optionStyle = (
    {
      light: {
        color: colorStyle.color.emphasis,
        _hover: {
          bg: colorStyle.background.selected,
        },
        cursor: 'pointer',
        _selected: {
          bg: colorStyle.background.selected,
        },
      },
      dark: {
        color: colorStyle.color.emphasis,
        _hover: {
          bg: colorStyle.background.selected,
        },
        cursor: 'pointer',
        _selected: {
          bg: colorStyle.background.selected,
        },
      },
    } as any
  )[colorMode];

  return {
    flexListStyle,
    descriptionStyle,
    optionStyle,
  };
}

export default useTargetListStyle;
